import React from "react"
import * as actions from "modules/reports/actions"
import * as appActions from "actions"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { withRouter } from "react-router-dom"
import AnimatedPageRoute from "modules/common/components/AnimatedPageRoute"
import ReportOverviewComponent from "modules/reports/components/ReportOverviewComponent"

const ReportContainer = props => <AnimatedPageRoute><ReportOverviewComponent {...props}/></AnimatedPageRoute>

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(Object.assign(actions, appActions), dispatch)
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReportContainer))